import { ILocale } from '@move-frontend/contentful-routes';
import { contentful } from '../../api/contentful';
import { CONTENT_CATEGORY_TYPE_ID } from '../../api/contentful/constants';
import {
	IContentCategoryAppliesTo,
	IContentCategoryEntry,
} from '../../api/contentful/types/IContentCategory';

export const ALL_CATEGORIES = 'ALL';
export interface ContentCategory {
	id: string;
	title: string;
}

export async function getContentCategoriesTitles(
	appliesTo: IContentCategoryAppliesTo,
	locale: ILocale,
): Promise<ContentCategory[]> {
	const newsStories = await contentful()
		.entry<IContentCategoryEntry>(CONTENT_CATEGORY_TYPE_ID)
		.getAll({
			locale: locale.code,
			'fields.appliesTo[match]': appliesTo,
		});

	return newsStories.map((contentCategory) => ({
		id: contentCategory.id,
		title: contentCategory.fields.title,
	}));
}
